module.exports = __webpack_public_path__ + "static/media/telegram-new.424da292.svg";